import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { GenericApiService } from "@pm-ui/core-services";

import { DataSeedingEndpoints } from "../config";

@Injectable({
  providedIn: 'root',
})
export class DataSeedingService {
  constructor(private genericApiService: GenericApiService) { }

  getSeedMethods<T>(): Observable<HttpResponse<T>> {
    return this.genericApiService.get<T>(DataSeedingEndpoints.GetSeedMethods);
  }

  executeSeedMethod<T>(model: { methodName: string }): Observable<HttpResponse<T>> {
    return this.genericApiService.post<T>(DataSeedingEndpoints.ExecuteSeedMethod, model);
  }
}
